import { Button, Card, Drawer } from '@weezevent/nacre';
import { FormInput } from '../../../../../../../components/form';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormCountrySelect } from '../../../../../../../components/form/FormCountrySelect';
import classes from '../../../../../style/main.module.scss';
import { Modes } from '../constants';

export const LegalEntitiesDrawer = ({ isOpen, onClose, mode, onSubmit, isSubmitting }) => {
    const { t } = useTranslation();

    const config = {
        [Modes.CREATE]: {
            title: t('sauron.financeModule.documentHeads.drawer.create.title'),
            subtitle: t('sauron.financeModule.documentHeads.drawer.create.subtitle'),
            submitCta: t('sauron.financeModule.documentHeads.drawer.create.submitCta')
        },
        [Modes.EDIT]: {
            title: t('sauron.financeModule.documentHeads.drawer.edit.title'),
            subtitle: t('sauron.financeModule.documentHeads.drawer.edit.subtitle'),
            submitCta: t('sauron.financeModule.documentHeads.drawer.edit.submitCta')
        }
    };

    return (
        <Drawer
            classNames={{
                root: classes.drawerRoot
            }}
            open={isOpen}
            onClose={onClose}
            header={<Drawer.Header title={config[mode].title} subtitle={config[mode].subtitle} icon="file" iconOffsets={[0, 1.5]} />}
            footer={
                <Drawer.Footer
                    actions={[
                        <Button as="button" key="cancel" onClick={onClose}>
                            {t('common.cta.cancel')}
                        </Button>,
                        <Button as="button" key="save" primary onClick={onSubmit} isLoading={isSubmitting}>
                            {config[mode].submitCta}
                        </Button>
                    ]}
                />
            }
        >
            <Card>
                <Card.Header>
                    <Card.Title>{t('common.information')}</Card.Title>
                </Card.Header>
                <Card.Content>
                    <FormInput name="name" label={t('sauron.financeModule.documentHeads.drawer.fields.name')} required />
                    <FormInput name="description" label={t('sauron.financeModule.documentHeads.drawer.fields.description')} />
                </Card.Content>
            </Card>
            <Card>
                <Card.Header>
                    <Card.Title>{t('sauron.financeModule.documentHeads.drawer.addressCard.title')}</Card.Title>
                </Card.Header>
                <Card.Content>
                    <FormInput name="street" label={t('sauron.financeModule.documentHeads.drawer.fields.street')} required />
                    <FormInput name="city" label={t('sauron.financeModule.documentHeads.drawer.fields.city')} required />
                    <FormInput name="zipCode" label={t('sauron.financeModule.documentHeads.drawer.fields.zipCode')} required />
                    <FormCountrySelect name="country" label={t('sauron.financeModule.documentHeads.drawer.fields.country')} required />
                </Card.Content>
            </Card>
            <Card>
                <Card.Header>
                    <Card.Title>{t('sauron.financeModule.documentHeads.drawer.vatCard.title')}</Card.Title>
                </Card.Header>
                <Card.Content>
                    <FormInput name="vatNumber" label={t('sauron.financeModule.documentHeads.drawer.fields.vatNumber')} required />
                    <FormCountrySelect name="vatCountry" label={t('sauron.financeModule.documentHeads.drawer.fields.vatCountry')} required />
                </Card.Content>
            </Card>
        </Drawer>
    );
};
